const initialState = {
  fetching: false,
  fetched: false,
  all: {
    adjustment: '',
    body: '',
    category: [],
    changed: '',
    created: '',
    data_file: '',
    frequency: '',
    nid: '',
    release: '',
    source: {
      id: '',
      title: '',
    },
    tags: [],
    title: '',
    uid: '',
    unit: '',
  },
  csvLink: '',
  error: null,
  dateRange: '',
  filterIsOpen: false,
  selectedEditline: 'editline1',
  dataSeries: [],
  selectedNode: {
    id: '',
    unit: '',
  },
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'DETAIL_FETCHING':
      return { ...state, fetching: true };
    case 'DETAIL_ERROR':
      return { ...state, error: payload.error, fetched: true };
    case 'DETAIL_FETCHED':
      return {
        ...state,
        all: payload,
        fetching: false,
        fetched: true,
      };
    case 'CSV_LINK_FETCHING':
      return { ...state, fetching: true };
    case 'CSV_LINK_ERROR':
      return { ...state, error: payload.error, fetched: true };
    case 'CSV_LINK_FETCHED':
      return {
        ...state,
        csvLink: payload,
        fetching: false,
        fetched: true,
      };
    case 'DATE_RANGE':
      return { ...state, dateRange: payload };
    case 'TOGGLE_CHART_FILTER':
      return { ...state, filterIsOpen: !state.filterIsOpen };
    case 'SELECTED_EDITLINE':
      return { ...state, selectedEditline: payload };
    case 'ADD_DATA_SERIES':
      return {
        ...state,
        dataSeries: payload,
      };
    case 'SELECTED_NODE':
      return {
        ...state,
        selectedNode: payload,
      };
    case 'RESET_DETAIL':
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/app/reducers/detail.js